import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { View, StyleSheet } from 'react-native';
import ShopeeDefaultImageSvg from '../../../assets/images/rn/ShopeeDefaultImageSvg';
var ShopeeDefaultImage = function ShopeeDefaultImage(props) {
  return /*#__PURE__*/React.createElement(View, _extends({}, props, {
    style: [Styles.container, props.style]
  }), /*#__PURE__*/React.createElement(ShopeeDefaultImageSvg, null));
};
var Styles = StyleSheet.create({
  container: {
    backgroundColor: 'rgba(250, 250, 250, 1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
});
export default ShopeeDefaultImage;